"use client";

import { SimpleGrid } from "@chakra-ui/react";
import { memo } from "react";

import CatalogItem from "@features/marketplace/catalog/CatalogItem";
import { ProductDetails } from "helpers/fakeData";
import ProductModal from "@features/marketplace/catalog/ProductModal";

interface Props {
  products: ProductDetails[];
  hideAddToCart?: boolean;
}

const CatalogGrid = ({ products, hideAddToCart }: Props) => {
  return (
    <>
      <SimpleGrid columns={{ base: 1, sm: 2, md: 3, lg: 4 }} gap={4} w="full">
        {products.map((item) => (
          <CatalogItem
            key={item.id}
            product={item}
            hideAddToCart={hideAddToCart}
          />
        ))}
      </SimpleGrid>
      <ProductModal />
    </>
  );
};

export default memo(CatalogGrid);
